import React from 'react'
import UtilitiesBanner from './UtilitiesBanner'
import UtilitiesServices from './UtilitiesServices'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'

function Utilities() {
    return (
        <div>
            <UtilitiesBanner />
            <UtilitiesServices/>
            <ProjectStats/>
            <TestimonialSlider/>
        </div>
    )
}

export default Utilities
